<div
  #fontSelectComponent
  id="fontSelectComponent"
  class="select select--font"
  (click)="toggleDropdown()"
>
  <div class="select__content">
    <span
      class="select__content--selected"
      [style]="'fontFamily:' + (ppSelectedFont ? ppSelectedFont.value : defaultFont)"
    >
      {{ ppSelectedFont ? ppSelectedFont.label : defaultFont }}
    </span>
  </div>

  <div class="select__caret select__caret--alwaysVisible">
    @if (!dropdown.visible) {
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    }
    @if (dropdown.visible) {
      <i class="fa fa-caret-up" aria-hidden="true"></i>
    }
  </div>
</div>
